import React, { useState } from 'react';
import { Modal, Tabs, Tab, Button, Form } from 'react-bootstrap';
import { FaCheckCircle } from 'react-icons/fa';
import { BasicInfoTab } from './BasicInfoTab';
import { SpecificAddonsTab } from './SpecificAddonsTab';
import { ProductRecipeTab } from './ProductRecipeTab';
import { MenuProvider } from '../context/MenuContext';
import { GlobalAlert } from '../../../global/components/GlobalAlert';

export const ItemModal = ({ 
  show, 
  onHide, 
  modalMode,
  // State from parent to provide to context
  itemFormData, setItemFormData,
  categories,
  sharedModGroups,
  selectedSharedGroups, setSelectedSharedGroups,
  productModGroups, setProductModGroups,
  bomItems, setBomItems,
  inventoryItems,
  productImageFile, setProductImageFile,
  productImagePreview, setProductImagePreview,
  handleShowModBom,
  handleItemSubmit,
  error, setError
}) => {
  const [itemModalTab, setItemModalTab] = useState("basic");

  const contextValue = {
    itemFormData, setItemFormData,
    categories,
    sharedModGroups,
    selectedSharedGroups, setSelectedSharedGroups,
    productModGroups, setProductModGroups,
    bomItems, setBomItems,
    inventoryItems,
    productImageFile, setProductImageFile,
    productImagePreview, setProductImagePreview,
    handleShowModBom
  };

  const handleClose = () => {
    setItemModalTab("basic");
    onHide();
  };

  return (
    <Modal show={show} onHide={handleClose} centered size="lg" backdrop="static">
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title style={{ color: "#1e3c72", fontWeight: 700 }}>
          {modalMode === "add" ? "Create New Menu Item" : "Edit Menu Item"}
        </Modal.Title>
      </Modal.Header>
      
      <Form onSubmit={handleItemSubmit}>
        <Modal.Body style={{ maxHeight: "70vh", overflowY: "auto" }}>
          <GlobalAlert message={error} onClose={() => setError("")} />
          
          <MenuProvider value={contextValue}>
            <Tabs activeKey={itemModalTab} onSelect={(k) => setItemModalTab(k)} className="mb-4">
              <Tab eventKey="basic" title="1. Basic Info & Shared Add-ons">
                <BasicInfoTab />
              </Tab>

              <Tab eventKey="specific" title="2. Specific Add-ons">
                <SpecificAddonsTab />
              </Tab>

              <Tab eventKey="recipe" title="3. Product Recipe">
                <ProductRecipeTab />
              </Tab>
            </Tabs>
          </MenuProvider>
        </Modal.Body>
        <Modal.Footer className="border-0 pt-0 mt-3 d-flex justify-content-between">
          <Button variant="light" onClick={handleClose}>Cancel</Button>
          <Button variant="primary" type="submit" style={{ background: "#1e3c72", border: "none" }}>
            <FaCheckCircle className="me-2" /> Save Menu Item
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};
